import { JSX, ReactNode} from "react";
import LoadingSpinner from "@app/shared/LoadingSpinner";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { WidgetIcon, WidgetHeaderProperties, WidgetProperties, WidgetTitleIconColor } from ".";

const determineIcon = (titleIcon: string): JSX.Element => {
  const size = "24";
  let colorClass = "default";

  switch (titleIcon) {
    case WidgetIcon.Critical:
      colorClass = WidgetTitleIconColor.Red;
      break;
    case WidgetIcon.Info:
      colorClass = WidgetTitleIconColor.Blue;
      break;
    case WidgetIcon.Warning:
      colorClass = WidgetTitleIconColor.Yellow;
      break;
  }

  return <QesIcon className={colorClass} height={size} iconName={titleIcon} width={size} isDecorative />
}

const Widget = (props: WidgetProperties): JSX.Element => {
  const { additionalClassNames = "", children } = props;

  return (
    <div className={`col-12 col-sm-6 col-lg-4 col-xl-3 col-xxl-2dot4 col-xxxl-2 col-4xl-1dot7 col-5xl-1dot5 col-6xl-1dot33 ni-widget ${additionalClassNames}`}>
      <div className='tile-item ellipsis'>
        <div className='d-flex flex-column box-style-1 white-bg project-tile-top ni-widget-content'>
          {children || <h5 className="ms-3 mb-3 text-muted text-wrap">Unable to Load Widget</h5>}
        </div>
      </div>
    </div>
  );
}

const WidgetLoading = (props: WidgetProperties): JSX.Element => {
  const { additionalClassNames = "", children } = props;

  return (
    <div className={`col-12 col-sm-6 col-lg-4 col-xl-3 col-xxl-2dot4 col-xxxl-2 col-4xl-1dot7 col-5xl-1dot5 col-6xl-1dot33 ni-widget ${additionalClassNames}`}>
      <div className='tile-item ellipsis'>
        <div className='box-style-1 white-bg project-tile-top ni-widget-content'>
          {children}
          <div className="ni-spinner-container">
            <LoadingSpinner />
          </div>
        </div>
      </div>
    </div>
  );
}

const WidgetHeader = (props: WidgetHeaderProperties): JSX.Element => {
  const { children, title, titleBackgroundColor, titleIcon} = props;

  return (<div className="d-flex flex-column align-items-start">
    <h3 className={`lead demibold mtb0 ni-title ${titleBackgroundColor}`}>
      {titleIcon && determineIcon(titleIcon)}
      {title}
      {children}
    </h3>
  </div>);
}

const WidgetFooter = (props: { children?: ReactNode }): JSX.Element => {
  return (<div className="ni-widget-footer">
    {props.children}
  </div>);
}



const WidgetBody = (props: { children?: ReactNode }): JSX.Element => {
  return (<div className='ni-widget-content-body'>
    {props.children}
  </div>);
}

export { Widget, WidgetBody, WidgetFooter, WidgetHeader, WidgetLoading };